// extracted by mini-css-extract-plugin
module.exports = {"lunbo":"lunbo-OO0YKu_w","dotCurrent":"dotCurrent-3xWPO9E7","box":"box-_JUl9NAc","image":"image-2KlTH75d","link":"link-3IhxBBev"};